import { render, staticRenderFns } from "./statoOrdini.html?vue&type=template&id=2348b422&scoped=true&"
import script from "./StatoOrdini.vue?vue&type=script&lang=js&"
export * from "./StatoOrdini.vue?vue&type=script&lang=js&"
import style0 from "./StatoOrdini.vue?vue&type=style&index=0&id=2348b422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348b422",
  null
  
)

export default component.exports